export const ADD_NEW_RELANCE = {
  title: 'Relance facture N°{code}',
  listeRetardPaiement: 'Liste des retards de paiement',
  filtre: {
    from: 'Du',
    to: 'Au',
    datePrevPaiement: 'Date prev. de paiement',
    dateFacture: 'Date de la facture',
    dateLastRelance: 'Date de la dernière relance',
    noDateLastRelance: 'Sans date de dernière relance',
    title: 'Filtre',
    sousTitle: 'Les filtres seront appliqués à la liste',
    errorDate: 'La date de début est plus grande que la date de fin',
    commercial: 'Commercial',
    payeur: 'Payeur(s)',
    blocageReglement: 'Blocage paiement',
    produits: 'Supports',
    comptesComptables: 'Compte comptable(s)',
    niveauDerniereRelance: 'Niveau dernière relance',
    modeReglement: 'Mode(s) de règlement',
    actions: {
      reinitialiser: 'Réinitialiser',
      appliquer: 'Appliquer',
    },
    nePasRelancer: 'Non relançable',
  },
  relance: 'Relance',
  messageRelance: 'Message de relance',
  actions: {
    cancel: 'Annuler',
    saveMasse: 'Tout enregistrer',
    reinitialiser: 'Réinitialiser la relance',
    reinitialiserTooltip: 'Permet de reinitialiser le texte de la relance',

  },
  numberRelance: {
    first: '1ERE RELANCE',
    other: 'EME RELANCE',
  },
  dateRelance: 'Le {date}',
  addSuccess: '1 relance créée',
  addSuccessMulti: ' relances créées',
  editSuccess: 'Modification de la relance réalisée avec succès',
  relancesGroupees: 'Création Relance',
  dateRelanceEdit: 'Date de relance',
  niveauRelance: 'Niveau de relance',
  messageError: 'Un seul payeur par relance',
  facturesNonRelancable: 'Les factures "{codes}" sont non relançables',
  factureNonRelancable: 'La facture "{code}" est non relançable',
  msgWarningDateRelance: 'Cette date est différente de celle dans le texte de relance',
  commentaire: 'Commentaire',
};

export const RELANCE = {
  titleRetard: 'Liste des retards de paiement',
  titleRelances: 'Liste des relances enregistrées',
  titleDetailRelance: 'Détail relance facture N° ',
  DetailRelance: 'Détail relance',
  nFacture: 'N° de facture',
  nCommande: 'N° de commande',
  annonceurs: 'Annonceur(s)',
  factureN: 'Facture',
  payeur: 'Payeur',
  compteComptable: 'Compte comptable',
  datePrev: 'Date prev. de paiement',
  dateFacture: 'Date fact.',
  commentaireRelance: 'Commentaire',
  dateLastRelance: 'Date de la dernière relance',
  retard: 'Retard',
  retards: 'Retards',
  montantTtc: 'Montant TTC',
  restantDu: 'Restant dû',
  agence: 'Agence',
  action: 'Action',
  relanceMaj: 'Relance',
  relanceMin: 'relance',
  newRelance: 'Créer',
  emailSuccess: 'Relance envoyé par mail',
  eme: 'ème',
  ere: 'ère',
  jours: 'Jour(s)',
  relancer: 'Relancer',
  groupedActions: 'Actions groupées',
  etat: {
    enregistre: 'Enregistré',
    envoye: 'Envoyé',
    archive: 'archivée',
  },
  niveauRelance: {
    niveau1: '1er relance ',
    niveau2: '2ème relance',
    niveau3: '3ème relance',
  },
  echDate: 'ech du ',
  popUpMail: {
    title: 'Rédiger votre email',
    inclureFacture: 'Inclure la facture',
    inclureCommande: 'Inclure la commande',
    libelleObjet: 'Facture n°{codeFacture} - {titreRelance}',
    contactTitle: 'Contacts Facture',
    clientTitle: 'Client Facture',
  },
  popUpPreventionRelance: {
    title: 'Etes-vous sûr de vouloir génerer la/les relance(s) ?',
    generer: 'Générer relance',
    regrouperParPayeur: 'Regrouper les échéances avec le même payeur.',
  },
  titlePopUpAnnulerRelance: 'Etes-vous sûr de vouloir annuler cette relance ?',
  annulerRelance: 'Annuler la relance',
  popUpMouvementsClients: {
    title: 'Informations factures',
    facture: 'Facture ',
    echDate: 'pour l\'écheance du ',
    du: 'du ',
    montant: 'd\'un montant de ',
  },
  supprimer: 'Supprimer',
  envoyer: 'Envoyer',
  etatRelance: 'Relance archivée',
  impossibleDeCreerLaRelance: 'Impossible de créer la relance car la facture a été indiquée comme non relançable par un utilisateur',
  destinataire: 'Envoyé à :',
  commentaire: 'Commentaire',
  envoiMailMasse: {
    titre: 'Envoyer par mail',
    steps: {
      selection: {
        titre: 'Choix des destinataires',
        tab: {
          relanceLibelle: 'Relance',
          date: 'Date',
          etat: 'Etat',
          numFacture: 'N° facture',
          dateFacture: 'Date facture',
          payeur: 'Payeur',
          annonceur: 'Annonceur',
          destinataire: 'Destinataire de l\'email',
        },
      },
      option: {
        titre: 'Envoi des emails',
      },
    },
    multiple: 'Multiple',
    sendMail: 'Envoyer les mails',
    sendingMail: 'Envoi des mails en cours',
    sendedMail: '{send} sur {total} mails envoyés',
    allMailSended: 'Tous les mails ont été envoyés avec succès',
    error: {
      objectRequired: 'Toutes les relances doivent avoir un objet',
      corpsRequired: 'Toutes les relances doivent avoir un contenu',
      fromRequired: 'Toutes les relances doivent avoir un expéditeur',
      toRequired: 'Toutes les relances doivent avoir au moins un destinataire',
      formatEmail: 'Le format de l\'email est incorrect',
      dupplicateMail: 'Une relance a une adresse mail en doublons',
      alreadyInCopy: 'Vous êtes déjà en copie de chaque mail, votre adresse ne peut pas être mis en tant que destinaire',
      pjTooBig: 'Une des pièces jointes est trop grande',
    },
  },
};

export const RELANCES_SAVE = {
  title: 'Relances enregistrées',
  actions: {
    relancesDesac: 'Afficher les relances désactivées',
    onlyRelanceAct: 'Masquer les relances désactivées',
    search: 'Rechercher',
    envoyer: 'Envoyer',
    filtre: 'Filtre',
    supprimer: 'Supprimer',
    archiver: 'Archiver',
    desarchiver: 'Désarchiver',
    editionMasse: 'Générer édition',
    enregistrer: 'Enregistrer',
    envoyerParMail: 'Envoyer par mail',
  },
  filtre: {
    to: 'Au',
    codeFacture: 'Code facture',
    dateFacture: 'Date de la facture',
    dateRelance: 'Date de la relance',
    title: 'Filtre',
    tiersRelance: 'Client: {client}',
    sousTitle: 'Les filtres seront appliqués à la liste',
    errorDate: 'La date de début est plus grande que la date de fin',
    actif: 'Actif',
    actions: {
      reinitialiser: 'Réinitialiser',
      appliquer: 'Appliquer',
    },
    comptesComptables: 'Compte(s) comptable(s)',
    payeur: 'Payeur(s)',
    etat: 'Etat(s)',
  },
  confEnvoie: '{number} relance(s) marquée(s) comme envoyé',
  confEnregistre: '{number} relance(s) marquée(s) comme enregistré',
  popUpConf: {
    titleEnregistreRelances: 'Etes-vous sûr de vouloir marquer comme \'enregistré\' ces relances ?',
    titleEnregistreRelance: 'Etes-vous sûr de vouloir marquer comme \'enregistré\' cette relance ?',
    titleEnvoyeRelances: 'Etes-vous sûr de vouloir marquer comme \'envoyé\' ces relances ?',
    titleEnvoyeRelance: 'Etes-vous sûr de vouloir marquer comme \'envoyé\' cette relance ?',
    yes: 'Oui',
    cancel: 'Annuler',
  },
  tab: {
    numberRelance: 'Relance',
    dateRelance: 'Date de relance',
    etat: 'Etat',
    numberFacture: 'N° facture',
    dateFacture: 'Date de la facture',
    payeur: 'Payeur',
    annonceurs: 'Annonceur(s)',
    montant: 'Montant TTC',
    agence: 'Agence',
    archive: 'Archivé',
    commentaire: 'Commentaire',
  },
  archivageDesarchiver: {
    archivage: 'Etes-vous sûr de vouloir archiver cette relance ?',
    desarchivage: 'Etes-vous sûr de vouloir désarchiver cette relance ?',
    desarchivageMulti: 'Etes-vous sûr de vouloir désarchiver ces relances ?',
    archivageMulti: 'Etes-vous sûr de vouloir archiver ces relances ',
  },
  messages: {
    success: {
      archivage: 'Relance archivée avec succès.',
      desarchivage: 'Relance désarchivée avec succès.',
      enregistrer: 'Relance marquer comme \'enregistré\' avec succès.',
      archivageMulti: 'Les relances ont été archiver avec succès.',
      desarchivageMulti: 'Les relances ont été désarchiver avec succès.',
      envoi: 'La relance a été marqué comme envoyer avec succès.',
    },
    errors: {
      relanceCannotBeDeactived: 'La relance ne peut pas avoir un état désactivé',
    },
  },
  popUpSuppression: {
    title: 'Etes-vous sûr de vouloir supprimer cette relance ?',
    titleMutlti: 'Etes-vous sûr de vouloir supprimer ces relances ?',
    success: {
      oneRelance: 'Relance supprimée avec succès',
      relanceMulti: 'Les relances ont été supprimées avec succès.',
    },
  },
};
